import styled from "@emotion/styled";
import { MDSIconButton } from "@/mds/components/buttons/icon-button/icon-button";
import { MDSButton } from "@/mds/components/buttons/button/button";

/**
 * Version-history arrow buttons. They use the Default MDSIconButton variant
 * (so disabled/opacity behavior is inherited), but the background + hover are
 * customized to the emphasis-light tokens so the arrows read as the same
 * emphasis-light group as the version pill. The icon color is intentionally
 * left untouched (stays icon.primary from the Default variant baseline).
 */
export const StyledArrowButton = styled(MDSIconButton)`
  background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};

  &[data-hovered]:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.hover};
  }
`;

/**
 * Version-history right-side action buttons ("Restore version" / "Return to
 * editing"). They use the EmphasisLight MDSButton variant for the light
 * emphasis background + hover, but the text and icon colors are overridden
 * back to their previous (Transparent variant) values so the foreground reads
 * exactly as it did before.
 */
export const StyledRightButton = styled(MDSButton)`
  color: ${({ theme }) => theme.colors.text.primary};

  .mds-icon {
    color: ${({ theme }) => theme.colors.icon.primary};
  }
`;

export const VersionHistoryBannerWrapper = styled.div`
  display: contents;

  [data-mds-name="banner"] {
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};
  }
`;

export const LeftSlotContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
  margin-left: calc(-1 * ${({ theme }) => theme.spacing["7"]} - 10px);
`;

export const RightSlotContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
`;

export const VersionSelectWrapper = styled.div`
  display: flex;
  align-items: center;

  .mds-button {
    /* react-aria sets data-pressed on the trigger while the menu is open */
    &[data-pressed] {
      background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.hover};
    }
  }
`;

export const ItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const ItemRight = styled.div`
  margin: auto;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["8"]};
`;

export const ItemTitleRow = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
`;

export const ItemSubtitleRow = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
